import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  ROOM_STAGE_LAYOUT_FEATURE_KEY,
  RoomStageLayoutState
} from "../reducers";

export const state = createFeatureSelector<RoomStageLayoutState>(
  ROOM_STAGE_LAYOUT_FEATURE_KEY
);

export const isLoading = createSelector(
  state,
  (state: RoomStageLayoutState) => state.isLoading
);

// The layout being set (optimistic), for the layout picker
export const layout = createSelector(
  state,
  (state: RoomStageLayoutState) => state.nextLayout || state.layout
);

// The layout 'videos' and 'audios' were computed for, for rendering the stage:
// the next layout comes with its own streams (e.g. Grid has no screen)
export const stageLayout = createSelector(
  state,
  (state: RoomStageLayoutState) => state.layout
);

export const videos = createSelector(
  state,
  (state: RoomStageLayoutState) => state.videos
);
export const videosSet = createSelector(
  state,
  (state: RoomStageLayoutState) => new Set(state.videos)
);

export const audios = createSelector(
  state,
  (state: RoomStageLayoutState) => state.audios
);

export const focus = createSelector(
  state,
  (state: RoomStageLayoutState) => state.focus
);

export const main = createSelector(
  state,
  (state: RoomStageLayoutState) => state.main
);
